var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDarkElisyan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2214,
    height: 682,
    viewBox: "0 0 2214 682",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 182V292L284 110V0L0 182Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 370V474L188 354V250L0 370Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 574V682L284 498L562 682V64L468 0V512L284 392L0 574Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M778.227 289.459H864.218V315.873H738V175.801H862.761V202.215H778.227V232.03H855.474V258.043H778.227V289.459Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.67 289.459H1083.5V315.873H965.448V175.801H1005.67V289.459Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.23 175.801H1219.46V315.873H1179.23V175.801Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.64 318.674C1376.43 318.674 1359.43 315.606 1345.63 309.469C1331.83 303.2 1322.11 294.729 1316.48 284.057L1350.88 270.249C1358.84 284.523 1374.49 291.66 1397.81 291.66C1409.08 291.66 1417.34 290.26 1422.58 287.458C1427.83 284.657 1430.45 281.122 1430.45 276.853C1430.45 271.917 1427.25 268.115 1420.84 265.447C1414.42 262.646 1402.96 259.644 1386.44 256.442C1377.3 254.575 1369.53 252.707 1363.12 250.84C1356.9 248.972 1350.58 246.504 1344.17 243.436C1337.95 240.234 1333.19 236.232 1329.89 231.43C1326.58 226.627 1324.93 221.024 1324.93 214.621C1324.93 201.948 1331.44 191.876 1344.46 184.406C1357.68 176.802 1373.52 173 1391.98 173C1408.5 173 1422.97 175.801 1435.41 181.404C1448.04 186.874 1457.86 194.544 1464.85 204.416L1431.04 217.823C1422.88 205.817 1409.86 199.814 1391.98 199.814C1383.62 199.814 1377.01 201.148 1372.16 203.816C1367.49 206.35 1365.16 209.685 1365.16 213.821C1365.16 218.223 1367.78 221.825 1373.03 224.626C1378.47 227.294 1388.77 230.229 1403.93 233.431C1410.15 234.765 1414.81 235.832 1417.92 236.632C1421.22 237.299 1425.6 238.433 1431.04 240.034C1436.67 241.502 1440.95 242.902 1443.86 244.236C1446.97 245.57 1450.47 247.371 1454.36 249.639C1458.24 251.907 1461.16 254.241 1463.1 256.643C1465.24 259.044 1466.99 261.979 1468.35 265.447C1469.9 268.782 1470.68 272.451 1470.68 276.453C1470.68 289.393 1463.78 299.664 1449.98 307.268C1436.38 314.872 1418.6 318.674 1396.64 318.674Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1722.17 175.801L1652.21 261.245V315.873H1612.28V261.245L1542.61 175.801H1588.08L1632.39 234.231L1676.7 175.801H1722.17Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1919.31 315.873L1907.06 290.66H1825.73L1813.49 315.873H1770.06L1841.48 175.801H1891.32L1963.03 315.873H1919.31ZM1838.56 264.847H1894.53L1866.54 207.618L1838.56 264.847Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2173.77 175.801H2214V315.873H2183.39L2095.94 230.229V315.873H2055.72V175.801H2086.32L2173.77 261.245V175.801Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M797.781 566L740.647 425.929H782.915L821.975 529.782L864.534 425.929H898.931L941.781 529.782L980.841 425.929H1023.11L965.975 566H920.21L881.732 473.553L843.546 566H797.781Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.54 539.587H1245.53V566H1119.31V425.929H1244.07V452.342H1159.54V482.157H1236.78V508.171H1159.54V539.587Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1481.06 566L1468.82 540.787H1387.49L1375.25 566H1331.82L1403.23 425.929H1453.08L1524.79 566H1481.06ZM1400.32 514.974H1456.29L1428.3 457.745L1400.32 514.974Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1657.7 539.587H1735.53V566H1617.47V425.929H1657.7V539.587Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1945.44 425.929V452.342H1890.35V566H1850.12V452.342H1795.32V425.929H1945.44Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2156.79 425.929H2196.72V566H2156.79V507.97H2081V566H2040.77V425.929H2081V481.557H2156.79V425.929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDarkElisyan);
export default __webpack_public_path__ + "static/media/logo_dark_elisyan.026ca25fae5bf549d68c347afe686744.svg";
export { ForwardRef as ReactComponent };